<div class="grid-container">
	<div class="grid-x grid-padding-x grid-padding-y grid-margin-x">
		<div class="cell">
			<label for="title">Title</label>
			<input id="title" [(ngModel)]="this.dashboard.title" type="text">
		</div>

		@for (column of dashboard.columns; track column; let i = $index) {
		<!--<div [ngClass]="getLayout(i)" class="widget-container cell" [dragula]="'widget-column'" [dragulaModel]='column'>-->
		<div [ngClass]="getLayout(i)" class="widget-container cell" cdkDropList [cdkDropListData]="dashboard.columns[i]" [cdkDropListId]="'column-' + i" [cdkDropListConnectedTo]="columnDropListIds" (cdkDropListDropped)="onWidgetDrop($event, i)">
			@for (widget of column; track widget; let x = $index) {
			<div class="cell widget">
				<h2>View {{widget.component}}</h2>
				<div class="widget-handle">
					<svg-icon icon="icon-arrows" class="handle vertical-align-middle white float-left cursor-pointer"></svg-icon>
					<svg-icon icon="icon-trash" class="vertical-align-middle white float-right cursor-pointer" (click)="delete(widget)"></svg-icon>
				</div>
			</div>
			}
		</div>
		}
	</div>

  <div class="grid-x grid-padding-x grid-padding-y grid-margin-x">
    @for (column of dashboard.columns; track column; let i = $index) {
      <div class="cell add-widget" [ngClass]="getLayout(i)" (click)="toggleMenu(i)">
        <svg-icon icon="icon-plus" class="white"></svg-icon>
      </div>
    }
  </div>
</div>
